<template>
    <table>
        <tr v-for="(hours, day) in computedHours" :key="day">
            <td class="pr-4"><b>{{ dayNames(day) }}</b></td>
            <td>
                <template v-if="hours.open">{{ hours.open | time }} &mdash; {{ hours.close | time }}</template>
                <template v-else><i>closed</i></template>
            </td>
        </tr>
    </table>
</template>

<script>
import SiteMixins from '@/mixins/SiteMixins';

export default {
    name: 'HourCharts',
    mixins: [
        SiteMixins,
    ],
    props: {
        hours: {
            type: Object,
            required: true,
        },
        abbreviate: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        computedHours() {
            return this.combinedHours(this.hours)
        }
    },
    methods: {
        dayNames(val) {
            let dayNames = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
            let dayNamesAbv = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
            
            dayNames.forEach((day, index) => {
                let finalDay = this.$options.filters.ucWords(this.abbreviate ? dayNamesAbv[index] : dayNames[index])
                val = val.replaceAll(day, finalDay)
            })
            
            return val
        },
    },
};
</script>

<style lang="scss">
.rating-value {
    font-size: 9px;
    font-weight: bold;
    font-style: italic;
}
</style>